export default __webpack_public_path__ + "static/media/analysis.5c00b355.jpg";